import React, { useRef, useState } from 'react';
import { UserCheck } from 'lucide-react';
import PortalMenu from '@stepflow/ui-shared/components/PortalMenu.jsx';
import { DECK_ICON_BUTTON } from '@stepflow/ui-shared/components/CommandDeck.jsx';
import StandinSettingsPanel from '@stepflow/ui-shared/components/standin/StandinSettingsPanel.jsx';

/**
 * YOUR STAND-IN — the room shortcut (STAND-IN.md §4, §9): in the composer's upper deck, ONLY for someone who
 * supervises an agent in this room. Indigo dot = on; amber badge = answers waiting for your confirmation here. The
 * same settings live in Profile → Stand-in (every room + the Away master switch).
 */
export default function StandinControl({ standin }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const s = standin || {};
  if (!s.loaded || !(s.eligible || []).length) return null;
  const setting = s.setting || {};
  const on = !!setting.enabled && s.away !== false;
  const waiting = (s.drafts || []).length;
  const names = (setting.agentIds || []).map((id) => ((s.eligible || []).find((a) => a.id === id) || {}).name || id);
  const title = on ? `${names.join(', ') || 'Your stand-in'} answers for you when you're mentioned${waiting ? ` — ${waiting} waiting for you` : ''}`
    : 'Your stand-in — let an agent you supervise answer for you when you\'re mentioned';
  return (
    <>
      <button ref={ref} type="button" data-testid="room-composer-standin" aria-label="Your stand-in" title={title}
        aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen((o) => !o)}
        className={`${DECK_ICON_BUTTON} relative ${on ? 'text-indigo-700' : ''}`}>
        <UserCheck className="h-4 w-4" aria-hidden />
        {waiting ? (
          <span data-testid="room-composer-standin-drafts"
            className="absolute -right-0.5 -top-0.5 min-w-[1rem] rounded-full bg-amber-500 px-1 text-center text-[9px] font-bold leading-4 text-white">{waiting}</span>
        ) : on ? <span aria-hidden className="absolute right-0.5 top-0.5 h-1.5 w-1.5 rounded-full bg-indigo-500" /> : null}
      </button>
      <PortalMenu anchorRef={ref} open={open} onClose={() => setOpen(false)} align="top-left">
        <div className="w-80 p-3" role="dialog" aria-label="Your stand-in" data-testid="standin-settings">
          <div className="mb-1 text-[13px] font-bold text-gray-900">Your stand-in</div>
          <p className="mb-2 text-[11px] leading-snug text-gray-500">
            When someone mentions you here, an agent you supervise answers <b>on your behalf</b> — always labelled as
            your stand-in, never as you. Every room + the master switch: Profile → Stand-in.
          </p>
          <StandinSettingsPanel standin={s} />
        </div>
      </PortalMenu>
    </>
  );
}
